import http from 'plugins/axios'

export default {
  //更新后的查询所有用户信息
  getUserList(data) {
    return http.get({
      url: `/la/admin/channel/tiger/list`,
      data
    })
  },
  exportExcel(data) {
    return http.get({
      url: `/la/admin/channel/tiger/list/excel`,
      data,
      responseType: 'blob',
    })
  },
  // 添加备注
  addRemark({ channelId, userId, remark }) {
    return http.post({
      url: `/channel/user/addRemark?channelId=${channelId}&remark=${remark}&userId=${userId}`,
    })
  },

  //钱包资产明细
  getDetail({ userId, coin }) {
    return http.get({
      url: `/channel/spot/detail?userId=${userId}&coin=${coin}`,
    })
  },
  //获取币种列表
  getCoinList() {
    return http.get({
      url: '/channel/common/coinList',
    })
  },
  //返佣统计记录
  getDetailRecord({ time, channelId }) {
    return http.get({
      url: `/channel/rebate/info?channelId=${channelId}&time=${time}`,
    })
  },
  getUserDetail(data) {
    console.log('data', data);
    return http.get({
      url: `/la/admin/channel/tiger/userDetail`,
      data,
    })
  },
}
